$(document).ready(function() {
    checkDescriptionPDP();
    // checkPDPVariantHeight(true);
    var isNumberClick = 0;
    var minPDPMediaSlide = 0;
    var maxPDPMediaSlide = $(".product__media--mobile-item").length;
    let touchStartX = 0;
    let touchEndX = 0;
    const slideContainer = document.querySelector('.product__media-list-mobile-container');

    $('.pdp-description-button-col').click(function() {
        var classActive = "." + $(this)[0].id;
        $(".pdp-description-button-col").removeClass("active");
        $(this).addClass("active");
        $(".pdp-description-content").removeClass("active");
        $(classActive).addClass("active")
    });

    $('.description__content-button-mobile').click(function() {
        if($(this).hasClass("plus")) {
            $(this).removeClass("plus");
        } else {
            $(this).addClass("plus");
        }
    });

    $('.description__btn-action').click(function() {
        $(this).removeClass("active")
        if($(this).hasClass("description__btn-show_more")) {
            $(this).next().addClass("active");
            if($(this).parent().prev().hasClass("product__info-wrapper")) {
                $(this).parent().prev().find(".description__content").removeClass("showless");
            } else {
                $(this).parent().prev().removeClass("showless");
            }
        } else {
            $(this).prev().addClass("active");
            if($(this).parent().prev().hasClass("product__info-wrapper")) {
                $(this).parent().prev().find(".description__content").addClass("showless");
            } else {
                $(this).parent().prev().addClass("showless");
            }
        }
    });

    $('.pdp-popup-table-detail').click(function() {
        sizeActive = $(this).data("size");
        pdpChangeModelAttribute(sizeActive);
    });

    $(document).on('click', '.pdp-sizeguide', function() {
        $(".balance-sizeguide-popup").addClass("active");
        pdpPopupModelAttribute();
    });

    $(document).on('click', '.product__info-wrapper-column .pdp-swatch', function() {
        var id = "." + $(this)[0].id;
        if(window.innerWidth > 767) {
            $('html, body').animate({
                scrollTop: $(id).offset().top - 100
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $(".product__media-list-mobile").offset().top - 100
            }, 500);

            $(".product__media-list-mobile-container").addClass("isColorVariantsClicked");
            var dataSlideClass = ".product__media-list-mobile " + id;
            var dataSlide = document.querySelector(dataSlideClass).getAttribute('data-mobileswatch');
            const containerPDPMEdiaSlideWidth = slideContainer.offsetWidth;
            const slideWidthTranslateX = -1 * dataSlide * containerPDPMEdiaSlideWidth + "px";
            slideContainer.style.transform = `translateX(${slideWidthTranslateX})`;
            slideContainer.setAttribute('data-slide', dataSlide);

            setTimeout(() => {
                $(".product__media-list-mobile-container").removeClass("isColorVariantsClicked");
            }, 1000);
        }

        return;
    });

    $('.btn-close-sizeguide').click(function() {
        $(".balance-popup").removeClass("active");
        $('html, body').animate({
            scrollTop: $(".sizeguide-container").offset().top - 100
        }, 1000);
    });

    $(document).on('click', '.product-variant-container .pdp-variants-label', function() {
        isNumberClick = 0;
    });

    $(document).on('click', '.slider-button-mobile .slider-button', function() {
        var isPrev = false;
        var isNext = false;
        const currentSlide = slideContainer.getAttribute('data-slide');

        if($(this).hasClass("slider-button-prev")) {
            isPrev = true;
        };

        if($(this).hasClass("slider-button-next")) {
            isNext = true;
        };

        handleSlideChange(isPrev, isNext, currentSlide, minPDPMediaSlide, maxPDPMediaSlide, slideContainer);
    });

    slideContainer.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
    });
    
    slideContainer.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].clientX;
        let isPrev = false;
        let isNext = false;
    
        const currentSlide = slideContainer.getAttribute('data-slide');
    
        if (touchStartX - touchEndX > 30) {
            isNext = true;
        } else if (touchEndX - touchStartX > 30) {
            isPrev = true;
        }
    
        if (isPrev || isNext) {
            handleSlideChange(isPrev, isNext, currentSlide, minPDPMediaSlide, maxPDPMediaSlide, slideContainer);
        }
    });

    // $(document).on('click', '.product .form__label', function() {
    //     // Run again when click another variants
    //     if (isNumberClick > 0) {
    //         checkPDPVariantHeight(false);
    //     } else {
    //         checkPDPVariantHeight(true);
    //     }
    //     isNumberClick = isNumberClick + 1;

    //     if($(this).hasClass("minius")) {
    //         $(this).removeClass("minius");
    //     } else {
    //         $(this).addClass("minius");
    //     }
    // });

    if ($(window).width() < 767) {
        window.onload = function () {
            setTimeout(function () {
                $('.slick_wrapper-container').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    centerMode: true
                });
                setTimeout(function () {
                    $('.related-product-loading-overlay').fadeOut(); // Hide overlay
                }, 500); // Thời gian chờ thêm 0.5s để load xong slick
            }, 1000); // Chờ 1000ms để đảm bảo nội dung được tải xong
        };
    }

    $(document).on("click", ".product__call-to-action-mobile .product-form__submit__btn", function () {
        $(".product__call-to-action .product-form__submit").trigger("click");
        $(this).addClass("isClicked");
        $(this).find(".loading__spinner").removeClass("hidden");
        setTimeout(() => {
            $(this).removeClass("isClicked");
            $(this).find(".loading__spinner").addClass("hidden");
        }, 1000);
    });
});

// function checkPDPVariantHeight(isFirstLoad) {
//     if ($(window).width() < 767) {
//         variantHeight = document.getElementsByClassName("product-variant-container");
//         if(isFirstLoad) {
//             for (i = 0; i < variantHeight.length; i++) {
//                 var vHeight = $(variantHeight[i].clientHeight)[0];
//                 var vHeightPx = vHeight + "px";
//                 $(variantHeight[i]).css("height", vHeightPx);
//                 $(variantHeight[i]).attr("data-height", vHeightPx);
//             }
//         } else {
//             for (i = 0; i < variantHeight.length; i++) {
//                 var vHeightPx = $(variantHeight[i]).attr("data-height");
//                 $(variantHeight[i]).css("height", vHeightPx);
//             }
//         }
       
//     }
// }

function pdpPopupModelAttribute() {
    var checkedInput = $(".pdp__input:checked");
    var sizeActive;
    if (checkedInput.length > 0) {
        sizeActive = checkedInput.data("size");
        pdpChangeModelAttribute(sizeActive);
    }
}

function pdpChangeModelAttribute(sizeActive) {
    $(".sizeguide-table-detail").removeClass("active");
    $(".pdp-model-active").removeClass("active");
    $(".pdp-popup-table-detail").removeClass("active");
    var modelClassActive = ".pdp-model-active-" + sizeActive;
    var tableClassActive =".table-detail-" + sizeActive;
    var popupTableClassActive= ".pdp-popup-table-size-" + sizeActive;
    $(popupTableClassActive).addClass("active");
    $(modelClassActive).addClass("active");
    $(tableClassActive).addClass("active");
    // $(".popup-sizeguide-content-container .model-size")[0].innerHTML = sizeActive;
}

function checkDescriptionPDP() {
    if($("#MainContent").hasClass("template-product")) {
        desc = document.getElementsByClassName("description__content");
        for (i = 0; i < desc.length; i++) {
            var descriptionHeight = $(desc[i].clientHeight)[0];
            var descriptionHeightPx = descriptionHeight + "px"
            $(desc[i]).css("height", descriptionHeightPx);
            $(desc[i]).parent().parent().removeClass("active");
            if (descriptionHeight > 200) {
                $(desc[i]).addClass("showless");
                $(desc[i]).parent().next().addClass("active");
                $(desc[i]).parent().next().find(".description__btn-show_more").addClass("active");
                $(desc[i]).parent().parent().removeClass("active")
                $(desc[i]).next().addClass("active");
                $(desc[i]).next().find(".description__btn-show_more").addClass("active");
            }
            
            if ($(window).width() < 767 && i > 0) {
                $(desc[i]).prev().addClass("plus");
            }
        }
    }
}

function handleSlideChange(isPrev, isNext, dataSlide, min, max, containerSelector) {
    const container = containerSelector;
    if (!container) return;
  
    const containerPDPMEdiaSlideWidth = container.offsetWidth;
  
    if (isPrev && dataSlide > min) {
      dataSlide--;
    } else if (isNext && dataSlide < max - 1) {
      dataSlide++;
    }
  
    const slideWidthTranslateX = -1 * dataSlide * containerPDPMEdiaSlideWidth + "px";
    container.style.transform = `translateX(${slideWidthTranslateX})`;
    container.setAttribute('data-slide', dataSlide);
  
    return dataSlide;
}
  
